import {ApplicationConfig, importProvidersFrom, inject, isDevMode, provideAppInitializer, provideZoneChangeDetection} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import {provideRouter} from '@angular/router';
import {routes} from './app.routes';
import {providePrimeNG} from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptors,
  withInterceptorsFromDi
} from "@angular/common/http";
import {authInterceptor} from "./shared/auth/auth.interceptor";
import {JwtInterceptor} from "./shared/auth/jwt.interceptor";
import {provideTransloco} from "@jsverse/transloco";
import {ConfirmationService, MessageService} from "primeng/api";
import {TranslocoHttpLoader} from "./transloco-http-loader";
import {AuthService} from "./shared/services/auth.service";
import {firstValueFrom} from 'rxjs';
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PopoverModule } from 'ngx-bootstrap/popover';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.app-dark',
          cssLayer: {
            name: 'primeng',
            order: 'base, primeng, theme'
          }
        }
      }
    }),
    importProvidersFrom(
      BsDropdownModule.forRoot(),
      TooltipModule.forRoot(),
      PopoverModule.forRoot()
    ),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor]), withInterceptorsFromDi(), withFetch()),
    {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
    provideTransloco({
      config: {
        availableLangs: ['de', 'en'],
        defaultLang: 'de',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    MessageService,
    ConfirmationService,
    provideAppInitializer(() => {
      const auth = inject(AuthService);
      auth.loadToken();
    }),
    provideAppInitializer(() => {
      const transloco = inject(TranslocoService);
      const defaultLang = transloco.getDefaultLang();
      transloco.setActiveLang(defaultLang);

      return firstValueFrom(transloco.load(defaultLang));
    }),
  ],
};
